"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    spinnerVariants: ()=>spinnerVariants,
    emphasisOptions: ()=>emphasisOptions,
    sizeOptions: ()=>sizeOptions
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const spinnerVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        circleSlot: '',
        spinnerSlot: '',
        iconSlot: 'text-primary-8',
        wrapperSlot: 'animate-fade-in-0-100'
    },
    variants: {
        size: {
            xs: {
                wrapperSlot: 'w-4'
            },
            sm: {
                wrapperSlot: 'w-6'
            },
            md: {
                wrapperSlot: 'w-16'
            },
            lg: {
                wrapperSlot: 'w-28'
            },
            xl: {
                wrapperSlot: 'w-36'
            }
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        }
    },
    defaultVariants: {
        size: 'md',
        emphasis: 'regular'
    },
    compoundVariants: [
        {
            emphasis: 'regular',
            class: {
                circleSlot: 'var(--color-primary-4)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'medium',
            class: {
                circleSlot: 'var(--color-primary-7)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'bold',
            class: {
                circleSlot: 'color-mix(in oklab, var(--color-actionSecondary-1) 20%, transparent)',
                spinnerSlot: 'var(--color-primary-2)',
                iconSlot: 'text-primary-2'
            }
        }
    ]
});
const sizeOptions = Object.keys(spinnerVariants.variants.size);
const emphasisOptions = Object.keys(spinnerVariants.variants.emphasis);
exports.emphasisOptions = __webpack_exports__.emphasisOptions;
exports.sizeOptions = __webpack_exports__.sizeOptions;
exports.spinnerVariants = __webpack_exports__.spinnerVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "emphasisOptions",
    "sizeOptions",
    "spinnerVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
